export { EloKlarnaIcon } from './klarna-icon'
